"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportsStatsTranslations = {
    "en": {
        maxTalkTime: "Max Talk Time",
        avgTalkTime: "Avg Talk Time",
        totalTimeLoggedInSince: "Total Time logged in (Since",
        totalTimeLoggedIn: "Total Time logged in",
    },
    "de": {
        totalTimeLoggedIn: "Gesamte eingeloggte Zeit",
        maxTalkTime: "Max. Gesprächszeit",
        avgTalkTime: "Durchschn. Gesprächszeit",
        totalTimeLoggedInSince: "Gesamte eingeloggte Zeit (seit",
    },
    "nl": {
        totalTimeLoggedIn: "Totale tijd ingelogd",
        maxTalkTime: "Max. praattijd",
        avgTalkTime: "Gem. praattijd",
        totalTimeLoggedInSince: "Totale tijd ingelogd (sinds",
    },
    "it": {
        totalTimeLoggedIn: "Tempo totale di accesso",
        maxTalkTime: "Tempo di conversazione massimo",
        avgTalkTime: "Tempo di conversazione medio",
        totalTimeLoggedInSince: "Tempo totale di accesso (da",
    },
    "fr": {
        totalTimeLoggedIn: "Temps total de connexion",
        maxTalkTime: "Temps de parole maximum",
        avgTalkTime: "Temps de parole moyen",
        totalTimeLoggedInSince: "Temps total de connexion (depuis",
    },
    "es": {
        totalTimeLoggedIn: "Tiempo total que estuvo conectado",
        maxTalkTime: "Tiempo máximo de conversación",
        avgTalkTime: "Tiempo promedio de conversación",
        totalTimeLoggedInSince: "Tiempo total que estuvo conectado (Desde",
    },
    "ja": {
        totalTimeLoggedIn: "合計ログイン時間",
        maxTalkTime: "最大対話時間",
        avgTalkTime: "平均対話時間",
        totalTimeLoggedInSince: "合計ログイン時間（開始日時：",
    },
    "en-GB": {
        totalTimeLoggedIn: "Total Time logged in",
        maxTalkTime: "Max Talk Time",
        avgTalkTime: "Avg Talk Time",
        totalTimeLoggedInSince: "Total Time logged in (Since",
    },
    "ru": {
        maxTalkTime: "Максимальное Время Разговора",
        avgTalkTime: "Среднее Время Разговора",
        totalTimeLoggedInSince: "Общее Время Онлайн(С",
        totalTimeLoggedIn: "Общее Время Онлайн",
    },
};
